import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {toggleProductNoteEditorVisible} from "../../../actions/selectionFunctions";
import {togglePulseFeatureInfoNote, changeCartFeature} from "../../../actions/actionFunctions";
import {setCartItemEditFeature} from "../../../actions/shoppingCartFunctions";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";

const AddProductNoteEditor = (props) => {

  const {selectionFeatureInfo, productNoteEditorVisible, intl, toggleProductNoteEditorVisible, activeQuoteIndex,
    pulseFeatureInfoNote, togglePulseFeatureInfoNote, wizardGroup, cartItemEditFeature, changeCartFeature,
    setCartItemEditFeature} = props;
  const [noteText, setNoteText] = useState("");

  useEffect(() => {
    // while editing a cart item we edit that cart item's note, not the feature's one
    setNoteText((cartItemEditFeature
      ? cartItemEditFeature.noteText
      : selectionFeatureInfo?.notesList[activeQuoteIndex]) || "");
  }, [selectionFeatureInfo, activeQuoteIndex, cartItemEditFeature]);

  const onNoteChange = (e) => {
    setNoteText(e.target.value);
    if (pulseFeatureInfoNote) {
      togglePulseFeatureInfoNote(false);
    }
  };

  const onNoteSaveClick = () => {
    if (cartItemEditFeature) {
      const updatedCartItem = Object.assign({}, cartItemEditFeature, {noteText});
      changeCartFeature(updatedCartItem, true); // skipOtherRules - note text doesn't affect other cart items
      // keep the edited cart item in sync, otherwise the footer's "update cart" would restore the old note
      setCartItemEditFeature(updatedCartItem);
    } else {
      selectionFeatureInfo.notesList[activeQuoteIndex] = noteText;
    }
    toggleProductNoteEditorVisible(false);
    if (pulseFeatureInfoNote) {
      togglePulseFeatureInfoNote(false);
    }
  };

  return (
    <div className={"product-note" + (productNoteEditorVisible ? " product-note--active" : "")
      + (pulseFeatureInfoNote ? " ui-quantity--pulsing-red" : "")}>
      <textarea name=""
                id=""
                cols="30"
                rows="10"
                className="product-note__textarea ui-textarea"
                placeholder={wizardGroup?.notePlaceholder || intl.formatMessage({id: "quotingTool.featureInfo.addNoteButton"})}
                value={noteText}
                onChange={onNoteChange} />
      <button className="product-note__button ui-button2 ui-button2--green" onClick={onNoteSaveClick}>
        <FormattedMessage id="quotingTool.featureInfo.saveNoteButton"/>
      </button>
    </div>
  )
};

AddProductNoteEditor.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  cartItemEditFeature: PropTypes.shape(cartItemInterface),
}

const mapStateToProps = (store) => {
  const {selectionFeatureInfo, productNoteEditorVisible, pulseFeatureInfoNote} = store.selectionState;
  return {
    selectionFeatureInfo,
    productNoteEditorVisible,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    pulseFeatureInfoNote,
    cartItemEditFeature: store.cartState.cartItemEditFeature,
  };
};

const mapDispatchToProps = {
  toggleProductNoteEditorVisible,
  togglePulseFeatureInfoNote,
  changeCartFeature,
  setCartItemEditFeature,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AddProductNoteEditor)
);
